export class BigQueryNativePitrConfig {
    'retentionDays';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BigQueryNativePitrConfig.attributeTypeMap;
    }
    constructor() {
    }
}
